
import { Password } from "primeng/password";

export const TenantConfigModel = {
	model: [
		{
			label: 'ID',
			key: 'id',
		},
		{
			label: 'Name',
			key: 'name',
		},
		{
			label: 'URL',
			key: 'url',
		},
		{
			label: 'Created',
			key: 'created',
		}
	],

	callBacks: {
		onRowEditInit: (row: any, model: any, extraData: any) => {}
	},
	formBuilderConfig: {
		integrationId: {
			DataType: 'Selector',
			UIControl: 'Dropdown',
			DisplayText: 'integrationType',
			Name: 'integrationId',
			options: [],
			UIOptions: {
				ShowClearButton: true
			},
			UIEvents: {
				onChange: ($event: any, formBuilderConfig:any, formGroup: any, extraData?: any, field?:any) => {
					if ($event) {
						formGroup?.get('integrationType')?.setValue($event.value);
					}
				}
			}
		},
		integrationType: {
			DataType: 'String',
			DisplayText: 'integrationType',
			Name: 'integrationType',
			hidden: true,
			required: false
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'id',
			hidden: true,
			required: false
		},
		name: {
			DataType: 'String',
			DisplayText: 'name',
			Name: 'name',
			required: false
		},
		url: {
			DataType: 'String',
			DisplayText: 'url',
			Name: 'url',
			isRequired: function(control) {
				const value = control?.value || '';
				const urlRegex = /^(https?:\/\/)([\w\-]+\.)+[a-z]{2,}(:\d+)?(\/[^\s]*)?$/i;
				return !urlRegex.test(value);
			},
		},
		credentials: {
			DataType: 'Object',
			username: {
				DataType: 'String',
				DisplayText: 'username',
				Name: 'username',
				required: true,
				UIEvents: {
					onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
						model['credentials.username'] = $event?.name;
					}}
			},
			password: {
				DataType: 'String',
				DisplayText: 'password',
				Name: 'password',
				isRequired: function(control, jsonModelService:any) {
					return jsonModelService.FindRootValue('id')? false : jsonModelService.IsEmpty();
				},
				UIEvents: {
					onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
						model['credentials.password'] = $event?.name;
					}}
			},
			
		}
	}
}
